/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateCardHolder200ResponseReissueOneOf
 */
export interface UpdateCardHolder200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateCardHolder200ResponseReissueOneOf
     */
    'cardType': UpdateCardHolder200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateCardHolder200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateCardHolder200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateCardHolder200ResponseReissueOneOfCardTypeEnum = typeof UpdateCardHolder200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateCardHolder200ResponseReissueOneOfCardTypeEnum];


